import { createBlueprint as e } from "@made-people/blueprint";
const n = e({
  slots: {
    wrapper: "relative group/link",
    label: "",
    icon: ""
  },
  variants: {
    style: {
      disc: {
        label: "pl-3 before:content-[''] before:absolute before:left-0 before:top-1/2 before:w-[5px] before:h-[5px] before:-translate-y-1/2 before:bg-current hover:before:animate-blink-square"
      },
      "disc-on-hover": {
        label: "pl-3 before:content-[''] before:absolute before:left-0 before:top-1/2 before:w-[5px] before:h-[5px] before:-translate-y-1/2 before:bg-current hover:before:animate-blink-square group-hover/card:before:animate-blink-square flex"
      },
      "no-underline": {
        label: ""
      },
      underline: {
        label: "underline underline-offset-4 group-hover/link:underline-offset-[6px] transition-all"
      }
    },
    size: {
      inherit: {
        wrapper: ""
      },
      "heading-2xs": {
        // wp
        wrapper: "text-heading-2xs"
      },
      "heading-xs": {
        // wp
        wrapper: "text-heading-xs"
      },
      "heading-sm": {
        // wp
        wrapper: "text-heading-sm"
      },
      sm: { wrapper: "" },
      // stronger
      md: { wrapper: "" },
      // stronger
      lg: { wrapper: "" },
      // stronger
      xl: { wrapper: "" }
      // stronger
    }
  },
  defaultVariants: {
    size: "inherit",
    style: "underline"
  }
});
export {
  n as linkStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
